import { AgGridReact } from "ag-grid-react";
import Cookies from "js-cookie";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FetchDataTypes } from "../../api/api";
import { Grid, GridApi, GridReadyEvent } from "ag-grid-community";
import { currencyFormat, formateDataPrec } from "../../utils/types";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import _ from "lodash";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { BASE_URL, API_KEY } from "../../api/api";
import { FeeSchedulesTable } from "./FeeSchedules";
import TableComponent from "./Test";

export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const FeeSchedules = () => {
  return (
    <div>
      <div className="header">
        <h1 className="header-title">Fee Schedules</h1>
      </div>
      <div className="row w-100 card p-4">
        <FeeSchedulesTable />
        {/* <TableComponent /> */}
      </div>
    </div>
  );
};

export { FeeSchedules };
